// src/pages/Cities.jsx
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Search, MapPin } from 'lucide-react';
import '../styles/cities.css';

const Cities = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedContinent, setSelectedContinent] = useState('All');
  
  // City data with continents
  const cities = [
    {
      id: 1,
      name: "Paris",
      country: "France",
      continent: "Europe",
      restaurants: 347,
      image: "https://images.unsplash.com/photo-1499856871958-5b9627545d1a?q=80&w=2070",
      featuredDish: "Coq au Vin"
    },
    {
      id: 2,
      name: "Amsterdam",
      country: "Netherlands",
      continent: "Europe",
      restaurants: 215,
      image: "https://images.unsplash.com/photo-1534351590666-13e3e96b5017?q=80&w=2070",
      featuredDish: "Stroopwafel"
    },
    {
      id: 3,
      name: "Barcelona",
      country: "Spain",
      continent: "Europe",
      restaurants: 283,
      image: "https://images.unsplash.com/photo-1539037116277-4db20889f2d4?q=80&w=2070",
      featuredDish: "Paella"
    },
    {
      id: 4,
      name: "Lisbon",
      country: "Portugal",
      continent: "Europe",
      restaurants: 176,
      image: "https://images.unsplash.com/photo-1585208798174-6cedd86e019a?q=80&w=2073",
      featuredDish: "Pastéis de Nata"
    },
    {
      id: 5,
      name: "Madrid",
      country: "Spain",
      continent: "Europe",
      restaurants: 253,
      image: "https://images.unsplash.com/photo-1543783207-ec64e4d95325?q=80&w=2070",
      featuredDish: "Cocido Madrileño"
    },
    {
      id: 6,
      name: "Milan",
      country: "Italy",
      continent: "Europe",
      restaurants: 198,
      image: "https://images.unsplash.com/photo-1603122630570-680e80004216?q=80&w=2070",
      featuredDish: "Risotto alla Milanese"
    },
    {
      id: 7,
      name: "New York",
      country: "United States",
      continent: "North America",
      restaurants: 412,
      image: "https://images.unsplash.com/photo-1496442226666-8d4d0e62e6e9?q=80&w=2070",
      featuredDish: "New York Cheesecake"
    },
    {
      id: 8,
      name: "Los Angeles",
      country: "United States",
      continent: "North America",
      restaurants: 324,
      image: "https://images.unsplash.com/photo-1534190760961-74e8c1c5c3da?q=80&w=2069",
      featuredDish: "California Roll"
    },
    {
      id: 9,
      name: "Toronto",
      country: "Canada",
      continent: "North America",
      restaurants: 186,
      image: "https://images.unsplash.com/photo-1517935706615-2717063c2225?q=80&w=2071",
      featuredDish: "Poutine"
    },
    {
      id: 10,
      name: "Dubai",
      country: "United Arab Emirates",
      continent: "Asia",
      restaurants: 297,
      image: "https://images.unsplash.com/photo-1512453979798-5ea266f8880c?q=80&w=2070",
      featuredDish: "Shawarma"
    },
    {
      id: 11,
      name: "Istanbul",
      country: "Turkey",
      continent: "Europe",
      restaurants: 265,
      image: "https://images.unsplash.com/photo-1524231757912-21f4fe3a7200?q=80&w=2071",
      featuredDish: "Kebab"
    },
    {
      id: 12,
      name: "Tokyo",
      country: "Japan",
      continent: "Asia",
      restaurants: 389,
      image: "https://images.unsplash.com/photo-1540959733332-eab4deabeeaf?q=80&w=2071",
      featuredDish: "Sushi"
    },
    {
      id: 13,
      name: "Singapore",
      country: "Singapore",
      continent: "Asia",
      restaurants: 253,
      image: "https://images.unsplash.com/photo-1525625293386-3f8f99389edd?q=80&w=2069",
      featuredDish: "Chili Crab"
    },
    {
      id: 14,
      name: "Sydney",
      country: "Australia",
      continent: "Oceania",
      restaurants: 198,
      image: "https://images.unsplash.com/photo-1506973035872-a4ec16b8e8d9?q=80&w=2070",
      featuredDish: "Barramundi"
    },
    {
      id: 15,
      name: "Cape Town",
      country: "South Africa",
      continent: "Africa",
      restaurants: 134,
      image: "https://images.unsplash.com/photo-1580060839134-75a5edca2e99?q=80&w=2071",
      featuredDish: "Bobotie"
    },
    {
      id: 16,
      name: "Rio de Janeiro",
      country: "Brazil",
      continent: "South America",
      restaurants: 176,
      image: "https://images.unsplash.com/photo-1483729558449-99ef09a8c325?q=80&w=2070",
      featuredDish: "Feijoada"
    }
  ];

  const continents = ["All", "Europe", "North America", "South America", "Asia", "Africa", "Oceania"];

  // Filter cities based on search query and selected continent
  const filteredCities = cities.filter(city => 
    (searchQuery === '' || 
     city.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
     city.country.toLowerCase().includes(searchQuery.toLowerCase())) &&
    (selectedContinent === 'All' || city.continent === selectedContinent)
  );

  return (
    <div className="cities-container">
      {/* Hero Banner */}
      <div className="cities-hero">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8 text-center">
              <h1 className="display-4 fw-bold text-white mb-4">Explore Culinary Destinations</h1>
              <p className="lead text-white mb-5">Discover halal restaurants in top cities around the world</p>
            </div>
          </div>
        </div>
      </div>

      {/* Search and Filter Section */}
      <div className="container mt-n5 mb-5">
        <div className="search-filter-container">
          <div className="search-container">
            <div className="input-group">
              <span className="input-group-text bg-white border-end-0">
                <Search size={18} />
              </span>
              <input
                type="text"
                className="form-control border-start-0 shadow-none"
                placeholder="Search cities or countries..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
            </div>
          </div>
          <div className="filter-container">
            <select 
              className="form-select shadow-none"
              value={selectedContinent}
              onChange={(e) => setSelectedContinent(e.target.value)}
            >
              {continents.map((continent, index) => (
                <option key={index} value={continent}>{continent}</option>
              ))}
            </select>
          </div>
        </div>
      </div>

      {/* Cities Grid */}
      <div className="container mb-5">
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h2 className="fw-bold m-0">
            {selectedContinent === 'All' 
              ? 'Popular cities around the world' 
              : `Popular cities in ${selectedContinent}`}
          </h2>
          <span className="text-muted">{filteredCities.length} cities</span>
        </div>

        <div className="row g-4">
          {filteredCities.map(city => (
            <div key={city.id} className="col-12 col-md-6 col-lg-4 col-xl-3">
              <Link to={`/city/${city.name.toLowerCase()}`} className="text-decoration-none">
                <div className="city-card">
                  <div className="city-card-image">
                    <img src={city.image} alt={city.name} />
                    <div className="city-card-overlay">
                      <span className="restaurant-count">{city.restaurants} Restaurants</span>
                    </div>
                  </div>
                  <div className="city-card-content">
                    <h3 className="city-name">{city.name}</h3>
                    <div className="d-flex justify-content-between align-items-center">
                      <span className="country">
                        <MapPin size={16} className="me-1" />
                        {city.country}
                      </span>
                      <span className="featured-dish">{city.featuredDish}</span>
                    </div>
                  </div>
                </div>
              </Link>
            </div>
          ))}
        </div>
      </div>

      {/* Featured City Section */}
      <div className="container mb-5">
        <div className="featured-city-section">
          <div className="row g-0">
            <div className="col-lg-6 featured-city-image">
              <img src="https://images.unsplash.com/photo-1512453979798-5ea266f8880c?q=80&w=2070" alt="Dubai" />
            </div>
            <div className="col-lg-6 featured-city-content">
              <h2 className="display-6 fw-bold">Featured: Dubai</h2>
              <p className="mb-3">Discover the culinary wonders of Dubai, where tradition meets innovation. With over 290 halal restaurants serving cuisines from around the world, Dubai offers a unique dining experience.</p>
              <p className="mb-4">From traditional Emirati dishes to international fusion cuisine, Dubai's food scene is as diverse as its population.</p>
              <Link to="/city/dubai" className="btn btn-outline-primary">Explore Dubai</Link>
            </div>
          </div>
        </div>
      </div>

      {/* Continent Sections */}
      <div className="container mb-5">
        <h2 className="fw-bold mb-4">Explore by Continent</h2>
        <div className="continent-section">
          {continents.filter(continent => continent !== "All").map((continent, index) => (
            <div key={index} className="continent-card" onClick={() => setSelectedContinent(continent)}>
              <div className="continent-count">{cities.filter(city => city.continent === continent).length}</div>
              <h3>{continent}</h3>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Cities;